export default __webpack_public_path__ + "static/media/Todo.cd04b975.jpeg";